import type { ApiEmbedSearchWidgetId } from '#/api/types/ApiTypedId';
import type { I18nLocale } from '#/i18n/types/I18nLocale';
import { embedSearchWidgetSearchJobsPath } from '#/modules/embedSearchWidget/jobs/routing/embedSearchWidgetJobs.paths';
import type { RadiusParam } from '#/modules/search/helpers/radius';
import { searchGetQueryParamsFromFiltersByName } from '#/modules/search/routing/helpers/searchGetQueryParamsFromFiltersByName';
import { searchJobsPathReference } from '#/modules/search/routing/search.paths';
import type { SearchJobFiltersByName } from '#/modules/search/types/FiltersByName/SearchJobFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchJobsPathByLocale } from './searchJobs.paths';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusParam;
  filtersByName?: Omit<SearchJobFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
  embedSearchWidgetId: ApiEmbedSearchWidgetId | null;
};

export function searchGetJobsPath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
  embedSearchWidgetId,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);

  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  if (embedSearchWidgetId) {
    return embedSearchWidgetSearchJobsPath.with({
      ...queryParams,
      lang: locale,
      embedSearchWidgetId,
    });
  }

  return searchJobsPathReference
    .with(queryParams)
    .replace('/-lang/-segment', searchJobsPathByLocale[locale]);
}
